import {
    INVOICE_RECEIVE,
    INVOICE_ERROR,
    INVOICE_CHANGE_MODE,
    INVOICE_CHANGE_CURRENTPAGE,
    INVOICE_SET_ORDER
} from '../ConstantsBrafab/constants';

import {
    ViewMode
} from '../constants';

import { error as errorReducer } from '../Reducers/Error.reducer';

const defaultState = {
    mode: ViewMode.List,
    list: [],
    invoice: {},
    totalCount: 0,
    errors: {},
};

export const invoice = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case INVOICE_RECEIVE:
        case INVOICE_CHANGE_MODE:
        case INVOICE_CHANGE_CURRENTPAGE:
        case INVOICE_SET_ORDER:
            return {
                ...state,
                errors: {},
                ...payload,
            };
        case INVOICE_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action),
            };
        default:
            return state;
    }
};
